module.exports = __webpack_public_path__ + "img/t12.dba4d930.jpg";